<div
  class="component-container sm:w-full md:w-[40rem] h-full flex flex-col justify-center">
  <div class="heading">
    Add Measurement
  </div>
  <hr>
  <div class="content flex flex-col">
    <app-text-input
      [parentFormGroup]="form"
      controlName="name"
      label="Measurement Name"
      [error]="errorMessages['name']"
      placeholder="Enter Name"
      [minLength]="validations.measurements.name.length.min"
      [maxLength]="validations.measurements.name.length.max"
      (checkForErrors)="checkForErrors('name')"
      class="w-full"
      type="small"
    ></app-text-input>
    <app-dropdown
      [parentFormGroup]="form"
      controlName="type"
      [options]="typeOptions"
      label="Data Type"
      [error]="errorMessages['type']"
      class="w-full"
      type="small"
    />
    <app-dropdown
      [parentFormGroup]="form"
      controlName="isActive"
      [options]="statusOptions"
      label="Status"
      [error]="errorMessages['isActive']"
      class="w-full"
      type="small"
    />
  </div>
  <hr>
  <div class="action-panel flex flex-row justify-end items-center">
    <div
      class="icon-panel-submit w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleSubmit()"
    >
      <app-icon icon="check"
                cssClass="icon-panel-icon"></app-icon>
    </div>
    <div
      class="icon-panel-cancel w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleCancel()"
    >
      <app-icon icon="close"
                cssClass="icon-panel-icon"></app-icon>
    </div>
  </div>
</div>
